<template lang="pug">
  .giftcard-balance-inner
    StaticImage.gc-placeholder(
      src="f_auto,w_372,h_167/cms/giftcards/Icon%20Assets/Gift_Card_Back_jtljc5.svg"
      :alt="__('Back of a gift card')"
      background-color="#ffffff"
      :width="372"
      :height="167"
    )
    .row
      b.font-size-xxs {{ __('Note') }}
      p.font-size-xxs {{ __('For traditional gift cards, your code can be found on the back of the card.') }}
      p.font-size-xxs
        | {{__('Digital gift card recipients can find their claim code within their e-mail, or within a provided link if received through text message.')}}
    .row.form
    p.font-weight-bold {{ __('Check Your Balance') }}
    giftcard-validator(
      :clear-on-submit="false"
      :showInlineErrors="true"
      :giftCardPage="true"
      button-text="Submit"
      @onValidGiftcard="onValidGiftCard"
    )
</template>
<script setup lang="ts">
import giftcardValidator from '@/js/components/payment/giftcard-validator.vue'

withDefaults(defineProps<{
  giftCardPage?: boolean
}>(), {
  giftCardPage: false,
})

const emit = defineEmits<{
  balance: [balance: number]
}>()

function onValidGiftCard(card: { code: string, balance: number }) {
  emit('balance', card.balance)
}
</script>

<style lang="scss" scoped>

  .no-margin-bottom {
    &, &.field-error {
      margin-bottom: 0;
    }
  }

  .field-error {
    margin-bottom: $space-xs;

    :deep() {
      input.input-touched {
        border-color: $color-red;
      }
    }
  }

  .gc-placeholder {
    margin-bottom: $space-m;
  }

  .giftcard-balance-inner {
    .row {
      flex-direction: column;
      padding: none;
      padding-bottom: $space-xs;
      margin-bottom: none;
      border-bottom: $border-width-thin solid $color-gray-light;
      &.form {
        border-bottom: none;
      }
    }

    p:last-child {
      margin-bottom: 0;
    }
  }

</style>
